require('popper.js');
window.jQuery = window.$ = require('jquery');
import 'bootstrap';
import LazyLoad from "vanilla-lazyload";
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faTwitter, faFacebookF, faInstagram, faYoutube, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { faUser, faUsers, faStar, faHandshake, faGlobe, faChevronDown } from '@fortawesome/pro-light-svg-icons';
import 'slick-carousel';

window.lottie = require('lottie-web');

library.add(faTwitter, faFacebookF, faInstagram, faYoutube, faLinkedin, faArrowRight, faUser, faUsers, faStar, faHandshake, faGlobe, faChevronDown, faChevronLeft, faChevronRight);
dom.i2svg();



$( document ).ready(function() {

    let hash = window.location.hash.replace('#', '');

    switch (hash) {
        case 'well-being':
            $('.content-cards .card.linked[data-target="#well_being_content"]').trigger('click');
            var target = '#well_being_content';
            break;
        case 'keynote-speakers':
            $('.content-cards .card.linked[data-target="#keynote_speakers_content"]').trigger('click');
            var target = '#keynote_speakers_content';
            break;
        case 'online-resources':
            $('.content-cards .card.linked[data-target="#online_resources_content"]').trigger('click');
            var target = '#online_resources_content';
            break;
    }

    $(target).parent().addClass('target');

    let targetElement = $('.target');

    if (targetElement.length > 0) {
        $('html, body').animate({
            scrollTop: targetElement.offset().top
        }, 750);
    }

    if ($('.homepage-animation').length > 0) {

        $('.homepage-animation').each(function (i, v) {

            lottie.loadAnimation({
                container: $(v).get(0), // the dom element that will contain the animation
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: $(v).data('json') // the path to the animation json
            });

        });
    }

    if ($('.hover-info').length > 0) {

        $('.hover-info .info-headings li').on('mouseover click', function () {
            let $this = $(this), $target = $($this.data('target'));

            $('.hover-info .info-text .block-content, .hover-info .info-headings li').toggleClass('show', false);

            $target.toggleClass('show', true);
            $this.toggleClass('show', true);
        });

    }

    if ($('.content-cards .card.linked').length > 0) {
        $('.content-cards .card.linked').each(function (i, v) {
            let $this = $(this), $target = $($this.data('target'));

            $target.on('show.bs.collapse', function () {
                $this.parent().toggleClass('show-cont', true);
                $this.parents('.content-cards').find('.card:not(.collapsed)').trigger('click');

                $($this.data('target')).parent().addClass('target');

                $('html, body').animate({
                    scrollTop: $('.target').offset().top
                }, 1000, function() {
                });

            });

            $target.on('hide.bs.collapse', function () {
                $this.parent().toggleClass('show-cont', false);
            });
        });

        // let hash = window.location.hash.replace('#', '');

        // switch (hash) {
        //     case 'well-being':
        //             $('.content-cards .card.linked[data-target="#well_being_content"]').trigger('click');
        //         break;
        //     case 'keynote-speakers':
        //             $('.content-cards .card.linked[data-target="#keynote_speakers_content"]').trigger('click');
        //         break;
        //     case 'online-resources':
        //             $('.content-cards .card.linked[data-target="#online_resources_content"]').trigger('click');
        //         break;
        // }
    }

    $('#contact-form form.wpcf7-form a.wpcf7-submit').on('click', function (e) {
        e.preventDefault();

        $('#contact-form form.wpcf7-form #contact-submit').trigger('click');
    });

    let hoverTimeout = {};

    const hoverTimeoutFunction = function ($element) {
        if (typeof hoverTimeout[$element.attr('aria-labelledby')] !== 'undefined' && hoverTimeout[$element.attr('aria-labelledby')] !== null) clearTimeout(hoverTimeout[$element.attr('aria-labelledby')]);

        hoverTimeout[$element.attr('aria-labelledby')] = null;

        hoverTimeout[$element.attr('aria-labelledby')] = setTimeout(function () {
            if ($('.dropdown-menu[aria-labelledby="' + $element.attr('aria-labelledby') + '"]:hover').length > 0) {
                hoverTimeoutFunction($element);
            } else {
                $element.parent().toggleClass('show', false);
                $element.toggleClass('show', false);
            }
        }, 2000);
    };

    $('header nav.navbar .navbar-nav li.nav-item').on('mouseover', function () {
        let $this = $(this);

        if (!window.matchMedia('(max-width: 768px)').matches) {

            $('header nav.navbar .navbar-nav li.nav-item').toggleClass('show', false);

            $('header nav.navbar .navbar-nav li.nav-item ul.dropdown-menu').toggleClass('show', false);

            $this.toggleClass('show', true);

            $this.find('ul.dropdown-menu').toggleClass('show', true);

            hoverTimeoutFunction($this.find('ul.dropdown-menu'));

        }
    });

    $('header nav.navbar .navbar-nav li.nav-item ul.dropdown-menu').on('mouseover', function () {
        let $this = $(this);

        if (!window.matchMedia('(max-width: 768px)').matches) hoverTimeoutFunction($this);
    });

    // Mega menu: Courses
    const $coursesItem = $('header nav.navbar .navbar-nav li.nav-item.has-mega').first();
    const $coursesLink = $coursesItem.children('a.nav-link').first();

    if ($coursesLink.length && $coursesItem.length) {
        $coursesItem.addClass('has-mega');

        // Courses should act as a toggle anchor, not navigate away.
        $coursesLink.attr('href', '#');

        // Hide default dropdown for Courses when custom mega menus are present
        $coursesItem.find('ul.dropdown-menu').addClass('d-none');

        // Move the mobile accordion panel inside the Courses <li> so it sits inline
        // between Courses and the next nav items when the navbar is open
        const $coursesPanel = $('#courses-mobile-panel');
        if ($coursesPanel.length) {
            $coursesItem.append($coursesPanel);
        }

        // Toggle mega menu / accordion on click
        $coursesLink.on('click', function (e) {
            const isMobile = window.matchMedia('(max-width: 992px)').matches;

            if (isMobile) {
                e.preventDefault();
                const isOpen = $coursesItem.hasClass('mobile-open');
                $coursesItem.toggleClass('mobile-open', !isOpen);
                $coursesPanel.toggleClass('show', !isOpen);
            } else {
                e.preventDefault();

                const $mega = $('#courses-mega');
                const isOpen = $mega.hasClass('show');

                // Toggle desktop mega
                $mega.toggleClass('show', !isOpen);
            }
        });

        // Prevent stale open state when switching viewport sizes.
        $(window).on('resize orientationchange', function () {
            $('#courses-mega').removeClass('show');
            $coursesItem.removeClass('mobile-open');
            $('#courses-mobile-panel').removeClass('show');
        });
    }

    $('header nav.navbar .navbar-nav li.nav-item a').on('click', function (e) {
        let $this = $(this);

        if ($this.parent().hasClass('has-mega')) {
            return;
        }

        if ($this.parent().hasClass('show')) window.location = $this.attr('href');
    });

    // When mobile navbar closes, reset the courses accordion
    const $headerNavbar = $('#header-navbar');

    if ($headerNavbar.length) {
        $headerNavbar.on('hidden.bs.collapse', function () {
            $coursesItem.removeClass('mobile-open');
            $('#courses-mobile-panel').removeClass('show');
        });
    }

});

var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var content = this.nextElementSibling;
        if (content.style.maxHeight) {
            content.style.maxHeight = null;
        } else {
            content.style.maxHeight = content.scrollHeight + "px";
        }
    });
}

$(function () {
    let lazyLoadInstances = new LazyLoad({
        elements_selector: ".lazy",
        callback_reveal: function (el) {
            if ($(el).hasClass('absolute')) $(el).css('position', 'absolute');
        }
    });
});

$('.slick-carousel').each(function (i, v) {
    let showDots = Boolean($(v).data('indicators')), showArrows = Boolean($(v).data('controls'));
    $(v).slick({
        centerMode: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 1000,
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true
                }
            }
        ],
        nextArrow: '<div class="slick-arrow-right"><i class="fas fa-chevron-right"></i></div>',
        prevArrow: '<div class="slick-arrow-left"><i class="fas fa-chevron-left"></i></div>',
    }).on('beforeChange', function () {
        $(v).addClass('transitioning');
    }).on('afterChange', function () {
        $(v).removeClass('transitioning');
    });
});

$('.image-carousel').slick({
    centerMode: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    speed:  1500,
    cssEase: 'ease-out',
    arrows: true,
    nextArrow: '.slick-arrow-right',
    prevArrow: '.slick-arrow-left',
    responsive: [
        {
            breakpoint: 768, // Adjust this value as needed
            settings: {
                centerMode: false,
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 992, // Adjust this value as needed
            settings: {
                centerMode: false,
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 1200, // Adjust this value as needed
            settings: {
                centerMode: true,
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        }
    ]
});
